import { render, staticRenderFns } from "./LandingMain.vue?vue&type=template&id=6b79d62e&scoped=true&"
import script from "./LandingMain.vue?vue&type=script&lang=js&"
export * from "./LandingMain.vue?vue&type=script&lang=js&"
import style0 from "./LandingMain.vue?vue&type=style&index=0&id=6b79d62e&prod&lang=css&"
import style1 from "./LandingMain.vue?vue&type=style&index=1&id=6b79d62e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b79d62e",
  null
  
)

export default component.exports